// extracted by mini-css-extract-plugin
export default {"listItem":"GripNotificationModal_listItem_Sfbg9","closeIcon":"GripNotificationModal_closeIcon_sC4jt","spinAround":"GripNotificationModal_spinAround_JYUoz"};